import React from "react";
import AboutPage from "~/src/components/home/pages/AboutPage";

export default function About() {
  return <AboutPage />;
}
